// Browser errors go to the gateway's log (design 7 §7.4): at most ten per page load, each sent once, the
// path without its query (the gateway strips it too).
import { CLIENT_BUILD } from "./socket";

const MAX_REPORTS = 10;

export function reportErrors(): void {
  const sent = new Set<string>();
  const send = (message: string, stack = "") => {
    const key = `${message}\n${stack}`.slice(0, 300);
    if (sent.size >= MAX_REPORTS || sent.has(key)) return;
    sent.add(key);
    const body = JSON.stringify({ message: message.slice(0, 500), stack: stack.slice(0, 2000), url: location.pathname, build: CLIENT_BUILD });
    fetch("/api/client-errors", { method: "POST", headers: { "Content-Type": "application/json" }, body, credentials: "same-origin", keepalive: true }).catch(
      () => {},
    );
  };
  addEventListener("error", (e) => send(String(e.message), e.error instanceof Error ? (e.error.stack ?? "") : ""));
  addEventListener("unhandledrejection", (e) => {
    const r: unknown = e.reason;
    send(r instanceof Error ? r.message : String(r), r instanceof Error ? (r.stack ?? "") : "");
  });
}
